<template>
    <div id="coursePackageList" @touchmove.stop="onTouchmove">
        <img
            v-if="pushCoursePackageList.length !== 0"
            @click="onShowPackageList"
            class="shopping-cart-icon"
            src="@/images/shopping-cart-icon.png"
        />
        <div class="package-list" v-if="isShowPackageList && pushCoursePackageList.length > 1">
            <div class="title">
                <span>共{{ pushCoursePackageList.length }}件商品</span>
                <van-icon @click="isShowPackageList = false" name="cross" />
            </div>
            <div class="list" @touchmove.stop="onTouchmove">
                <div class="item" v-for="item in pushCoursePackageList" :key="item.id">
                    <img :src="item.liveSellImage" />
                    <div>
                        <div class="package-title">{{ item.title }}</div>
                        <div>
                            <div>
                                <span class="package-price">¥{{ item.price / 100 }}</span>
                                <span class="original-price">¥{{ item.originalPrice / 100 }}</span>
                            </div>

                            <span class="buy-btn-disabled" key="btn" v-if="!item.onSale">已下架</span>
                            <span class="buy-btn" @click="onActivePackage(item, 'Click')" key="btn" v-else>抢 购</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="payment-dialog" v-if="activePackage">
            <div class="payment-content">
                <van-icon class="close-icon" @click="onClosePaymentDialog" name="cross" />
                <div class="title">直播特惠</div>
                <img class="cover" :src="activePackage.liveSellImage" />
                <div class="course-name">{{ activePackage.title }}</div>
                <div class="price" v-if="activePackage.onSale">
                    <span>¥{{ activePackage.price / 100 }}</span>
                    <span class="original-price">¥{{ activePackage.originalPrice / 100 }}</span>
                </div>
                <div class="buy-btn" @click="onBuyCoursePackage">立即抢购</div>
            </div>
        </div>
    </div>
</template>
<script>
import { getCourseInfo, liveCoursePackage } from '@/utils/api.js'
import { getTradeStatus } from '@/utils/api.js'
import { getUserInfo } from '@/utils/login.js'

export default {
    props: ['pushProductList', 'courseNo'],
    watch: {
        pushProductList: function () {
            this.updateCoursePackageList()
        },
        courseNo: function () {
            this.liveCoursePackageApi()
        },
    },
    data() {
        return {
            isShowPackageList: false,
            activePackage: null,
            pushCoursePackageList: [],
        }
    },
    created() {
        // 默认查询一次已购买课程
        this.userProductAliasIds = []
        this.getTradeStatusApi()
    },
    methods: {
        onTouchmove() {},
        onShowPackageList() {
            this.liveCoursePackageApi()
            this.isShowPackageList = true
        },
        onActivePackage(item, action) {
            if (!this.activePackage || this.activePackage.packageNo !== item.packageNo) {
                if (action === 'Click') {
                    this.activePackage = item
                } else if (action === 'Push') {
                    console.log('推送商品', item)
                    const _aliasId = item.sellExtra ? item.sellExtra.aliasId : ''
                    // 推送弹窗查看当前商品是否 已购买
                    if (!this.userProductAliasIds.includes(parseInt(_aliasId))) {
                        this.activePackage = item
                    }
                }
            }
        },
        onClosePaymentDialog() {
            this.activePackage = null
        },
        onBuyCoursePackage() {
            this.$emit('buyCoursePackage', this.activePackage)
            this.isShowPackageList = false
            this.activePackage = null
        },
        updateCoursePackageList() {
            const currentProduct = this.pushProductList[0]
            // pop：新增 rollback 删除  refresh 刷新
            if (currentProduct.type === 'pop') {
                const timeNum = Math.floor(Math.random() * 2000)
                let status = true
                for (let index = 0; index < this.pushCoursePackageList.length; index++) {
                    const item = this.pushCoursePackageList[index]
                    if (item.packageNo === currentProduct.productNo) {
                        this.onActivePackage(item, 'Push')
                        status = false
                        break
                    }
                }
                if (status) {
                    setTimeout(() => {
                        this.getCourseInfoApi(currentProduct.productNo, false)
                    }, timeNum || 2000)
                }
            } else if (currentProduct.type === 'rollback') {
                for (let index = 0; index < this.pushCoursePackageList.length; index++) {
                    const item = this.pushCoursePackageList[index]
                    if (item.packageNo === currentProduct.productNo) {
                        this.pushCoursePackageList.splice(index, 1)
                        if (this.activePackage && currentProduct.productNo === this.activePackage.packageNo) {
                            this.onClosePaymentDialog()
                        }
                        break
                    }
                }
            } else if (currentProduct.type === 'refresh') {
                for (let index = 0; index < this.pushCoursePackageList.length; index++) {
                    const item = this.pushCoursePackageList[index]
                    if (item.packageNo === currentProduct.productNo) {
                        this.getCourseInfoApi(currentProduct.productNo, true)
                        break
                    }
                }
            }
        },
        getCourseInfoApi(courseNo, isUpdate) {
            getCourseInfo(courseNo).then((res) => {
                if (res.data) {
                    if (isUpdate) {
                        for (let index = 0; index < this.pushCoursePackageList.length; index++) {
                            const item = this.pushCoursePackageList[index]
                            if (item.packageNo === courseNo) {
                                this.pushCoursePackageList[index] = res.data
                                break
                            }
                        }
                        this.onClosePaymentDialog()
                        this.$forceUpdate()
                    } else {
                        this.pushCoursePackageList.push(res.data)
                        this.onActivePackage(res.data, 'Push')
                    }
                }
            })
        },
        liveCoursePackageApi() {
            if (!this.courseNo) return
            liveCoursePackage({
                courseNo: this.courseNo,
            }).then((res) => {
                if (res.data && res.data.length !== 0) {
                    this.pushCoursePackageList = res.data
                    if (res.data.length === 1) {
                        this.onActivePackage(res.data[0], 'Push')
                    }
                }
            })
        },
        getTradeStatusApi() {
            const userInfo = getUserInfo()
            if (userInfo) {
                getTradeStatus({ aliasFlag: true, userId: userInfo.id })
                    .then((res) => {
                        this.userProductAliasIds = res.data.aliasIds || []
                        this.liveCoursePackageApi()
                    })
                    .catch(() => {
                        this.liveCoursePackageApi()
                    })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
#coursePackageList {
    .shopping-cart-icon {
        position: fixed;
        bottom: 100px;
        right: 20px;
        width: 50px;
        height: 50px;
        z-index: 200;
        cursor: pointer;
    }
    .package-list {
        position: fixed;
        z-index: 2;
        bottom: 0;
        right: 0;
        width: 100%;
        padding-bottom: 20px;
        background: #fff;
        z-index: 201;
        .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
            padding: 0 20px;
            font-size: 14px;
            .van-icon {
                cursor: pointer;
                font-size: 18px;
            }
        }
        .list {
            overflow-x: hidden;
            overflow-y: scroll;
            height: 200px;
            .item {
                padding: 6px 16px;
                margin-bottom: 6px;
                display: flex;
                justify-content: space-between;
                img {
                    width: 128px;
                    height: 72px;
                    border-radius: 4px;
                }
                > div {
                    flex-grow: 1;
                    margin-left: 16px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    > div {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 3px;
                        font-size: 13px;
                        align-items: center;
                        font-weight: 700;
                    }
                }
                .package-title {
                    font-size: 14px;
                    font-weight: 700;
                    color: #333;
                    line-height: 1.4em;
                }
                .package-price {
                    font-size: 13px;
                    color: #f00;
                }
                .original-price {
                    color: #999;
                    font-size: 12px;
                    margin-left: 4px;
                    font-weight: 400;
                    display: inline-block;
                    transform: scale(0.9);
                    text-decoration: line-through;
                }
                .buy-btn-disabled,
                .buy-btn {
                    background: #f00;
                    padding: 4px 8px;
                    border-radius: 10px;
                    color: #fff;
                    cursor: pointer;
                }
                .buy-btn-disabled {
                    background: #e1e1e1;
                    color: #999;
                    padding: 4px 10px;
                    font-size: 12px;
                }
            }
        }
    }
    .payment-dialog {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba($color: #333, $alpha: 0.4);
        z-index: 999;
        display: flex;
        justify-content: center;
        align-items: center;
        .payment-content {
            background: #fff;
            width: 240px;
            border-radius: 5px;
            border: 1px solid rgba(151, 151, 151, 1);
            position: relative;
            padding: 0 20px;
            .close-icon {
                font-size: 16px;
                position: absolute;
                top: 16px;
                right: 16px;
                cursor: pointer;
                color: #c9c6c6;
            }
            .title {
                line-height: 60px;
                font-size: 24px;
                text-align: center;
                color: #4a4a4a;
            }
            .cover {
                width: 240px;
                border-radius: 4px;
                display: block;
                margin: 0 auto;
            }
            .course-name {
                font-size: 17px;
                line-height: 24px;
                color: #6a696a;
                margin: 7px auto 14px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .price {
                font-size: 30px;
                color: #f34747;
                line-height: 42px;
                font-weight: 600;
                color: rgba(255, 56, 6, 1);
            }
            .original-price {
                color: #c9c6c6;
                font-size: 16px;
                margin-left: 10px;
                font-weight: 400;
                text-decoration: line-through;
            }
            .buy-btn {
                background: linear-gradient(45deg, #ff0000, #ff5700);
                width: 240px;
                margin: 8px auto 28px;
                height: 42px;
                line-height: 42px;
                font-size: 21px;
                border-radius: 4px;
                font-weight: 400;
                text-align: center;
                color: #fff;
                &.unsale-btn {
                    color: #999;
                    background: #f4f4f5;
                    font-size: 18px;
                }
            }
        }
    }
}
@media all and (orientation: landscape) and (min-aspect-ratio: 16/10) {
    #coursePackageList .payment-dialog {
        .payment-content {
            padding: 30px 20px 0;
            .close-icon {
                top: 10px;
                right: 10px;
            }
            .buy-btn {
                width: 220px;
                height: 36px;
                line-height: 36px;
                font-size: 18px;
            }
        }
        .course-name,
        .title {
            display: none;
        }
    }
}
</style>
